/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ResolveCandidatesResponse {
  present_job_candidate_ids?: string[];
  present_profile_ids?: string[];
  absent_profile_ids?: string[];
}
